import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-facebook',
  templateUrl: './icon-facebook.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFacebookComponent {}
